var CurrentUser = require("lib/account/CurrentUser");
var ReactTooltip = require("react-tooltip");

require("writing/evaluations/evaluation_tags.scss");

class EvaluationTags extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			tags: null, startingTags: null, showMore: false
		};
	}

	isEditable() {
		if (this.props.editable == undefined) {
			return CurrentUser.isAdmin();
		} else {
			return this.props.editable;
		}
	}

	componentDidMount() {
		this.fetchTags();			
	}

	selectTag(name) {
		var tagSelected = "";
		var newTags = this.state.tags.map(function(t){
			if (t['name'] == name) {
				tagSelected = t['selected']
				return _.extend({}, t, { selected: !t['selected'] })
			} else {
				return t;
			}
		});

		var newStartingTags = this.state.startingTags.map(function(t){
			if (t['name'] == name) {
				tagSelected = t['selected']
				return _.extend({}, t, { selected: !t['selected'] })
			} else {
				return t;
			}
		});

		this.setState({tags: newTags, startingTags: newStartingTags })
		if (!tagSelected) {
			this.saveSelectedTag(name);
		} else {
			this.deleteSelectedTag(name);
		}
	}

	saveSelectedTag(name) {
		Mycroft.newEvent({ category: "Response", action: "add-tag", label: name });

		var params = {
			parent_type: "activity",
			parent_id: this.props.response.id,
			title: name
		}
		CurrentUser.api().postTags(params, $wr.apiHandler(function(serverResponse) {
		}.bind(this)));
	}

	deleteSelectedTag(name) {
		Mycroft.newEvent({ category: "Response", action: "remove-tag", label: name });

		var params = {
			parent_type: "activity",
			parent_id: this.props.response.id,
		}
		CurrentUser.api().deleteTag(name,params, $wr.apiHandler(function(serverResponse) {
		}.bind(this)));
	}

	fetchTags() {
		var params = {
			parent_type: "activity",
			parent_id: this.props.response.id 
		}

		CurrentUser.api().getTags(params, $wr.apiHandler(function(serverResponse) {
			var selectedTags = _.select(serverResponse.tags, function(st) {
				return st['selected'];
			});

			if (this.isEditable()) {
				var unselectedTags = _.select(serverResponse.tags, function(st) {
					return !st['selected'];
				});
				var startingTags = _.sample(unselectedTags, 6);
				var combinedTags = selectedTags.concat(startingTags);

				this.setState({ tags: serverResponse.tags, startingTags: combinedTags });

			} else {
				this.setState({ tags: serverResponse.tags, startingTags: selectedTags });				
			}
		}.bind(this)));
	}

	showTags() {
		this.setState({ showMore: true });
	}

	displaySmallTags(tags) {
		return tags.map(function(t, i){
			var className = "tagContainer " + t['type'];

			var innerClassName = "evaluationTag " + t['type'];
			if (t['selected']) {
				innerClassName += " activeTag";
			} 
			return (
				<div className={ className } data-tip={ t['teacher_description'] } 
					onClick={ this.selectTag.bind(this, t['name']) } key={ i }> 

					<span className={ innerClassName }>
						{t['name']}
					</span>
				</div>
			);
		}.bind(this))
	}

	displayExpandedTags(tags) {
		return tags.map(function(t, i) {
			var expandedClassName = "expandedTag activeTag " + t['type'];
			return (
				<div className={ expandedClassName } key={ i }>
					<span className={ t['type'] + " title" }>
					 	{ t['name'] }
					</span>
					 <span className="feedback">
					 	{ t['student_description'] }
					 </span>
				</div>
			);
		}.bind(this));
	}

	render() {
		if (this.state.startingTags && this.state.startingTags.length > 0) {

			if (this.isEditable()) {

				if (this.state.showMore) {
					var tagDisplays = this.displaySmallTags(this.state.tags);
					tagDisplays.push(<ReactTooltip effect="solid" key="tip1" />);

				} else {
					var tagDisplays = this.displaySmallTags(this.state.startingTags);
					tagDisplays.push(<ReactTooltip effect="solid" key="tip2" />);

					var moreContent = (
						<a className="moreTagsLink" onClick={ this.showTags }>
							More
						</a>
					);
				}
			} else {
				var tagDisplays = this.displayExpandedTags(this.state.startingTags);
			}

			return (
				<span className="evaluationTags"> 
					<span>
						{ tagDisplays }
						{ moreContent }
					</span>
				</span>
			);
		} else {
			return (<span></span>)
		}
	}
};

EvaluationTags.propTypes = StrictPropTypes({
	response: PropTypes.object.isRequired,
	editable: PropTypes.bool
});

module.exports = EvaluationTags;



// WEBPACK FOOTER //
// ./modules/components/writing/evaluations/EvaluationTags.js